export default __webpack_public_path__ + "src/img/esempio-qr.png";